import { render, staticRenderFns } from "./PasswordCheckEmail.vue?vue&type=template&id=2d8f1d94&scoped=true&"
import script from "./PasswordCheckEmail.vue?vue&type=script&lang=ts&"
export * from "./PasswordCheckEmail.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordCheckEmail.vue?vue&type=style&index=0&id=2d8f1d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f1d94",
  null
  
)

export default component.exports